export const ChargeWaiverRegistrationConstant = {
    CATEGORY: "Charge",
    TITLE: "Charge Waiver Registration",
    WAIVER_REASON_CODE: "Waiver Reason Code",
    CHARGE_TYPE: "Charge Type",
    SUB_CHARGE_TYPE: "Sub Charge Type",
    CHARGE_DESCRIPTION: "Charge Description",
    ACTIVE_IND: "Active Ind",
}
export const ChargeWaiverRegistrationRequiredFieldList: string[] = [
    'waiverReasonCode',
    'activeInd',
];
